import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TCreateInvoiceTemplateRequest,
  TCreateInvoiceTemplateResponse,
} from "../createInvoiceTemplate/createInvoiceTemplate.schema";

/**
 * @description
 * Updates an existing Invoice Template for a company.
 * Sends PATCH request to la-forge route: PATCH /api/invoices/templates/:id
 *
 * @param axios - injected axios instance from AbstractApiClient
 * @param id - invoice template ID to update
 * @param params - typed invoice template payload (partial updates allowed)
 * @returns updated invoice template data
 */
export const updateInvoiceTemplate =
  (axios: IAxiosInstance) =>
  async (
    id: string,
    params: Partial<TCreateInvoiceTemplateRequest>
  ): Promise<TCreateInvoiceTemplateResponse> => {
    const response = await axios.noRetry.patch(
      `/api/invoices/templates/${id}`,
      params
    );
    const resData = response.data;

    if (resData?.success) {
      return resData.data;
    }

    throw new Error(resData?.error || "Error updating invoice template");
  };
